// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Quality from "../views/Quality.vue";

export default [
  {
    path: "/quality",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Calidad",
        component: Quality,
        meta: {
          title: "Calidad",
        },
      },
    ],
  },
];
